import * as React from 'react'

import DetailedPricingModal from 'main/components/lead/DetailedPricingModal'
import { SchoolPage_school } from 'main/pages/School/gql'
import { formatCurrencyRange } from 'main/util/currency'
import { IPricingRange } from 'main/util/profile'
import { TFunction, useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { i18nKeyPrefix } from '../i18n'

// TODO: (neftaly) Rename this style file before shipping v2
import {
  EmptyPricingContainer,
  LinkContainer,
  PricingContainer,
  PricingSubText,
  PricingSubTextContainer,
  PricingText,
  StyledNativeLink,
} from './Pricing.styles'

import { tuitionPriceRange } from './util'

const PRE = `${i18nKeyPrefix}-FULL-PRICING`

interface IProps {
  school: SchoolPage_school
}

export default function FullPricing(props: IProps) {
  const { school } = props
  const { tuitionBillingPolicy } = school
  const { weeklyBillingAccepted } = tuitionBillingPolicy

  const [displayModal, setDisplayModal] = React.useState<boolean>(false)
  const priceRange = tuitionPriceRange(school)
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return priceRange ? (
    <PricingContainer>
      {renderPricingRange(priceRange, weeklyBillingAccepted, t)}
      <LinkContainer>
        <StyledNativeLink
          data-pendo="school-page-detailed-pricing-link"
          onClick={() => setDisplayModal(true)}
        >
          {t(`${PRE}-DETAILED`)}
        </StyledNativeLink>
      </LinkContainer>
      {displayModal && (
        <DetailedPricingModal schoolId={school.id} onRequestClose={() => setDisplayModal(false)} />
      )}
    </PricingContainer>
  ) : (
    <EmptyPricingContainer />
  )
}

function renderPricingRange(
  priceRange: IPricingRange,
  weeklyBillingAccepted: boolean,
  t: TFunction,
) {
  const formatOpts = { separator: t(`${PRE}-SEPARATOR`) }
  const visibleWeeklyPricing = priceRange.weeklyMax !== null && priceRange.weeklyMin !== null

  if (weeklyBillingAccepted && visibleWeeklyPricing) {
    return (
      <>
        <PricingText>
          {t(`${PRE}-PER-WEEK`, {
            range: formatCurrencyRange(priceRange.weeklyMin!, priceRange.weeklyMax!, formatOpts),
          })}
        </PricingText>
        <PricingSubTextContainer>
          <PricingSubText>
            {t(`${PRE}-OR-PER-MONTH`, {
              range: formatCurrencyRange(priceRange.min, priceRange.max, formatOpts),
            })}
          </PricingSubText>
        </PricingSubTextContainer>
      </>
    )
  }

  return (
    <PricingText>
      {t(`${PRE}-PER-MONTH`, {
        range: formatCurrencyRange(priceRange.min, priceRange.max, formatOpts),
      })}
    </PricingText>
  )
}
